import React from "react";
import { Button } from "uikit";
import styled from "styled-components";

import { StyledRow } from "../../../../../../../../../../../components/common";

const StyledRowWrap = styled(StyledRow)`
	overflow: hidden;
	bottom: 0px;
	right: 0px;
`;

const Footer: React.FC<Footer.Props> = ({
	texts,
	onReset,
	onCancel,
	onApply,
}) => (
	<StyledRowWrap
		justify="space-between"
		alignItems="center"
		p="10px"
		gap="10px"
		w="100%"
	>
		<Button.Button
			variant="secondary"
			text={texts.reset}
			onClick={onReset}
		/>
		<StyledRow gap="10px">
			<Button.Button
				variant="secondary"
				text={texts.cancel}
				onClick={onCancel}
			/>
			<Button.Button
				variant="primary"
				text={texts.apply}
				onClick={onApply}
			/>
		</StyledRow>
	</StyledRowWrap>
);

declare namespace Footer {
	interface Props {
		texts: {
			reset: string;
			cancel: string;
			apply: string;
		};
		onReset: () => void;
		onCancel: () => void;
		onApply: () => void;
	}
}

export default Footer;
